import { CarrierType, TaxInfo } from '../../types/common';
import getCustomerTaxInfo from './getCustomerTaxInfo';
import saveCustomerTaxInfo from './saveCustomerTaxInfo';

const getTaxInfoPayload = (taxInfo: TaxInfo): TaxInfo => {
  const payload = {
    ...(taxInfo.type === 'PERSONAL'
      ? {
          type: taxInfo.type,
          canCreditNote: taxInfo.canCreditNote,
          invoiceCarrierId: taxInfo.invoiceCarrierId,
          ...(taxInfo.invoiceCarrierId !== CarrierType.CARRIER_NORMAL_INVOICE
            ? { invoiceCarrierNumber: taxInfo.invoiceCarrierNumber }
            : {}),
        }
      : {
          type: taxInfo.type,
          companyName: taxInfo.companyName,
          companyAddress: taxInfo.companyAddress,
          companyVatNumber: taxInfo.companyVatNumber,
          canCreditNote: taxInfo.canCreditNote,
        }),
  };
  return payload;
};

export { getCustomerTaxInfo, saveCustomerTaxInfo, getTaxInfoPayload };
